import { prepareCreateBasketPayload } from './payloads';
import * as _actionsBasket from '../actions/basket';

export const createBasket = (userDataEC, startDate, actionsBasket: typeof _actionsBasket) => {
  const basketPayload = prepareCreateBasketPayload('', userDataEC.industry, startDate);

  return actionsBasket.createBasket(basketPayload).catch((err: any) => console.error(err));
};

export const removeFromBasket = (basketEntryId, userDataEC, actionsBasket: typeof _actionsBasket, urn: any) => {
  const payload = {
    entries: [basketEntryId],
    basketreference: userDataEC.basketInfo.basketreference,
    basket: userDataEC.basketInfo.basket,
  };

  return actionsBasket.removeFromBasketByPayload(payload, urn);
};

export const updateBasketEntry = (newbasketdata: any, basketEntryId, actionsBasket: typeof _actionsBasket) => {
  const payload = {
    ...newbasketdata,
    entry: basketEntryId,
  };

  return actionsBasket.editInBasket(payload);
};
